import {
  FieldType,
  FilterField,
  FilterVocabulary,
  StaticVocabulary
} from '@core/filters/path-filter/vocabulary/vocabulary';
import {
  FilterOpName,
  LiteralKind,
  fieldPath,
  pathKey
} from '@core/filters/path-filter/wire';

import {
  AvailableFilterField,
  FilterDataType
} from '@shared/components/filter-query-builder/filter.models';
import { availableLanguages } from '@shared/types/translation.type';

const EMPTINESS: FilterOpName[] = ['is_empty', 'is_not_empty'];
const COMPARISONS: FilterOpName[] = [
  'equals',
  'not_equals',
  'greater_than',
  'greater_than_or_equal',
  'less_than',
  'less_than_or_equal',
  'between'
];

const BY_TYPE: Partial<
  Record<FilterDataType, { type: FieldType; ops: FilterOpName[]; kind: LiteralKind }>
> = {
  [FilterDataType.NUMBER]: {
    type: 'NUMBER',
    ops: [...COMPARISONS, 'is_any_of', ...EMPTINESS],
    kind: 'number'
  },
  [FilterDataType.UID]: {
    type: 'UID',
    ops: ['is_any_of', 'is_none_of', 'equals', 'not_equals', ...EMPTINESS],
    kind: 'uid'
  },
  [FilterDataType.DURATION]: {
    type: 'DURATION',
    ops: [...COMPARISONS, ...EMPTINESS],
    kind: 'duration'
  },
  [FilterDataType.TEXT]: {
    type: 'TEXT',
    ops: [
      'contains',
      'not_contains',
      'starts_with',
      'ends_with',
      'equals',
      'not_equals',
      ...EMPTINESS
    ],
    kind: 'string'
  }
};

/**
 * The grid's rows are not a catalogue entity, so its Path fields are the classic builder's own.
 * Their labels are already in the user's language, hence the same text for every locale.
 */
export function jobImportVocabulary(fields: AvailableFilterField[]): FilterVocabulary {
  const root = fields.flatMap((field): FilterField[] => {
    const spec = BY_TYPE[field.dataType];
    if (!spec) return [];
    const path = fieldPath(...field.field.split('.'));
    return [
      {
        key: pathKey(path),
        path,
        label: Object.fromEntries(availableLanguages.map((lang) => [lang, field.label])),
        type: spec.type,
        operators: spec.ops,
        literalKinds: Object.fromEntries(spec.ops.map((op) => [op, [spec.kind]])),
        ...(field.entityType ? { uidEntityType: field.entityType } : {})
      }
    ];
  });
  return new StaticVocabulary({
    entityType: 'JOB',
    allowsSelfRef: false,
    allowsRelativeDate: false,
    root,
    scoped: new Map(),
    associations: [],
    selfFields: [],
    sortable: []
  });
}
